import { render, staticRenderFns } from "./RowHead.vue?vue&type=template&id=3472bd3c&scoped=true"
import script from "./RowHead.vue?vue&type=script&lang=ts"
export * from "./RowHead.vue?vue&type=script&lang=ts"
import style0 from "./RowHead.vue?vue&type=style&index=0&id=3472bd3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3472bd3c",
  null
  
)

export default component.exports